import { inject } from '@angular/core';
import {
  patchState,
  signalStore,
  withMethods,
  withState,
} from '@ngrx/signals';
import { firstValueFrom } from 'rxjs';

import { encodeApiError, TApiErrorResponse } from '@sandbox-platform/shared-ui';

import { CommissionPaymentApiService } from '../../../../services/commission-payment-api.service';
import { CommissionPaymentDTO } from '../../../../types/commission-payment.types';

interface CommissionPaymentDetailState {
  payment: CommissionPaymentDTO | null;
  loading: boolean;
  error: string | TApiErrorResponse | null;
}

const initialState: CommissionPaymentDetailState = {
  payment: null,
  loading: false,
  error: null,
};

export const CommissionPaymentDetailStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store, apiService = inject(CommissionPaymentApiService)) => ({
    async loadPayment(id: string): Promise<void> {
      patchState(store, { loading: true, error: null });
      try {
        const response = await firstValueFrom(apiService.getById(id));
        patchState(store, { payment: response.data });
      } catch (error) {
        patchState(store, {
          error: encodeApiError(error, 'Failed to load payment'),
        });
      } finally {
        patchState(store, { loading: false });
      }
    },

    reset(): void {
      patchState(store, { payment: null, error: null });
    },

    clearError(): void {
      patchState(store, { error: null });
    },
  }))
);

export type CommissionPaymentDetailStoreType = InstanceType<
  typeof CommissionPaymentDetailStore
>;
